'use client';

import { APP_VERSION } from '../../constants/appVersion';
import { useEffect } from 'react';

/**
 * Versão do build no console e em `window`. Montado no provider raiz para valer
 * em toda página, inclusive 404 e tela de erro.
 *
 * Vive em `shared/helpers` e não no módulo `checkout`: `checkout` é lazy-loaded,
 * e import estático dele no provider raiz puxaria tudo para o bundle inicial.
 */
export function useBuildVersion(): void {
  useEffect(() => {
    (window as Window & { __APP_VERSION__?: string }).__APP_VERSION__ =
      APP_VERSION;

    // eslint-disable-next-line no-console
    console.info('Build version:', APP_VERSION);
  }, []);
}
